import React, { useEffect, useState } from 'react'
import './GalleryAutoGrid.scss'
import GallerySlider from './GallerySlider'
import IMG1 from './OriginalImages/img1.jpg'
import IMG2 from './OriginalImages/img2.jpg'
import IMG3 from './OriginalImages/img3.jpg'
import IMG4 from './OriginalImages/img4.jpg'
import IMG5 from './OriginalImages/img5.jpg'
import IMG9 from './OriginalImages/img9.jpg'
import IMG10 from './OriginalImages/img10.jpg'
import IMG11 from './OriginalImages/img11.jpg'
import IMG12 from './OriginalImages/img12.jpg'
import IMG13 from './OriginalImages/img13.jpg'
import IMG26 from './OriginalImages/img26.jpg'
import IMG28 from './OriginalImages/img28.jpg'
import IMG29 from './OriginalImages/img29.jpg'
import IMG30 from './OriginalImages/img30.jpg'
import IMG49 from './OriginalImages/img49.jpg'
import IMG50 from './OriginalImages/img50.jpg'
import IMG51 from './OriginalImages/img51.jpg'
import IMG52 from './OriginalImages/img52.jpg'
import IMG53 from './OriginalImages/img53.jpg'
import IMG57 from './OriginalImages/img57.jpg'
import IMG58 from './OriginalImages/img58.jpg'
import IMG59 from './OriginalImages/img59.jpg'
import IMG60 from './OriginalImages/img60.jpg'
import IMG67 from './OriginalImages/img67.jpg'
import IMG69 from './OriginalImages/img69.jpg'
import IMG79 from './OriginalImages/img79.jpg'
import IMG80 from './OriginalImages/img80.jpg'
import IMG81 from './OriginalImages/img81.jpg'
import IMG82 from './OriginalImages/img82.jpg'
import IMG83 from './OriginalImages/img83.jpg'
import IMG84 from './OriginalImages/img84.jpg'
import BLUR1 from './BlurredImage/img1.jpg'
import BLUR2 from './BlurredImage/img2.jpg'
import BLUR3 from './BlurredImage/img3.jpg'
import BLUR4 from './BlurredImage/img4.jpg'
import BLUR5 from './BlurredImage/img5.jpg'
import BLUR9 from './BlurredImage/img9.jpg'
import BLUR10 from './BlurredImage/img10.jpg'
import BLUR11 from './BlurredImage/img11.jpg'
import BLUR12 from './BlurredImage/img12.jpg'
import BLUR13 from './BlurredImage/img13.jpg'
import BLUR26 from './BlurredImage/img26.jpg'
import BLUR28 from './BlurredImage/img28.jpg'
import BLUR29 from './BlurredImage/img29.jpg'
import BLUR30 from './BlurredImage/img30.jpg'
import BLUR49 from './BlurredImage/img49.jpg'
import BLUR50 from './BlurredImage/img50.jpg'
import BLUR51 from './BlurredImage/img51.jpg'
import BLUR52 from './BlurredImage/img52.jpg'
import BLUR53 from './BlurredImage/img53.jpg'
import BLUR57 from './BlurredImage/img57.jpg'
import BLUR58 from './BlurredImage/img58.jpg'
import BLUR59 from './BlurredImage/img59.jpg'
import BLUR60 from './BlurredImage/img60.jpg'
import BLUR67 from './BlurredImage/img67.jpg'
import BLUR69 from './BlurredImage/img69.jpg'
import BLUR79 from './BlurredImage/img79.jpg'
import BLUR80 from './BlurredImage/img80.jpg'
import BLUR81 from './BlurredImage/img81.jpg'
import BLUR82 from './BlurredImage/img82.jpg'
import BLUR83 from './BlurredImage/img83.jpg'
import BLUR84 from './BlurredImage/img84.jpg'

const GalleryAutoGrid = () => {
  const [ClickedIndex, setClickedIndex] = useState(null)
  const Pictures = [
    {
      actual_image: IMG1,
      backgroundImage: BLUR1
    },
    {
      actual_image: IMG2,
      backgroundImage: BLUR2
    },
    {
      actual_image: IMG3,
      backgroundImage: BLUR3
    },
    {
      actual_image: IMG4,
      backgroundImage: BLUR4
    },
    {
      actual_image: IMG5,
      backgroundImage: BLUR5
    },
    {
      actual_image: IMG9,
      backgroundImage: BLUR9
    },
    {
      actual_image: IMG10,
      backgroundImage: BLUR10
    },
    {
      actual_image: IMG11,
      backgroundImage: BLUR11
    },
    {
      actual_image: IMG12,
      backgroundImage: BLUR12
    },
    {
      actual_image: IMG13,
      backgroundImage: BLUR13
    },
    {
      actual_image: IMG26,
      backgroundImage: BLUR26
    },
    {
      actual_image: IMG28,
      backgroundImage: BLUR28
    },
    {
      actual_image: IMG29,
      backgroundImage: BLUR29
    },
    {
      actual_image: IMG30,
      backgroundImage: BLUR30
    },
    {
      actual_image: IMG49,
      backgroundImage: BLUR49
    },
    {
      actual_image: IMG50,
      backgroundImage: BLUR50
    },
    {
      actual_image: IMG51,
      backgroundImage: BLUR51
    },
    {
      actual_image: IMG52,
      backgroundImage: BLUR52
    },
    {
      actual_image: IMG53,
      backgroundImage: BLUR53
    },
    {
      actual_image: IMG57,
      backgroundImage: BLUR57
    },
    {
      actual_image: IMG58,
      backgroundImage: BLUR58
    },
    {
      actual_image: IMG59,
      backgroundImage: BLUR59
    },
    {
      actual_image: IMG60,
      backgroundImage: BLUR60
    },
    {
      actual_image: IMG67,
      backgroundImage: BLUR67
    },
    {
      actual_image: IMG69,
      backgroundImage: BLUR69
    },
    {
      actual_image: IMG83,
      backgroundImage: BLUR83
    },
    {
      actual_image: IMG84,
      backgroundImage: BLUR84
    },
    {
      actual_image: IMG79,
      backgroundImage: BLUR79
    },
    {
      actual_image: IMG80,
      backgroundImage: BLUR80
    },
    {
      actual_image: IMG81,
      backgroundImage: BLUR81
    },
    {
      actual_image: IMG82,
      backgroundImage: BLUR82
    },
  ]
  const blurDivs = document.querySelectorAll('.item')
  blurDivs.forEach(div => {
    const image = div.querySelector('img')

    function loaded() {
      div.classList.add('loaded')
    }

    if (image.complete){
      loaded()
    } else {
      image.addEventListener('load', loaded)
    }
  })

  const onPictureClick = (index) => {
    setClickedIndex(index)
  }

  const onCloseClick = () => {
    setClickedIndex(null)
  }

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className='GalleryAutoGrid' onContextMenu={handleContextMenu}>
        {Pictures.map((data, index) => (
          <div
            className={`item img${index + 1}`}
            style={
              {
                background:`url(${data.backgroundImage})`,
                backgroundSize:'cover',
                backgroundPosition:'center'
              }
            }
            onClick={() => {setClickedIndex(index); console.log('Selected image:::::', index)}}
            key={index}
          >
            <img src={data.actual_image} alt='' loading='lazy' draggable={false}/>
          </div>
        ))}
      </div>
      {ClickedIndex !== null && <GallerySlider slides={Pictures} index={ClickedIndex} onPictureClick={onPictureClick} onCloseClick={onCloseClick}/>}
    </>
  )
}

export default GalleryAutoGrid